import { encounterField } from '../../shared/array-types';
import { phpJsonString, phpJsonTruthy } from './php-json-values';

/** Travel/display falls back on an empty prefix; the native shell retains explicit empty/zero. */
export function encounterZoneLabel(row: unknown, fallbackEmptyPrefix = true): string | number {
    const ownPrefix = encounterField(row, 'encounter_zone_prefix');
    const prefix = (fallbackEmptyPrefix ? (phpJsonTruthy(ownPrefix) ? ownPrefix : null) : ownPrefix)
        ?? encounterField(row, 'location_zone_prefix') ?? '';
    const number = encounterField<string | number>(row, 'encounter_zone_number') ?? null;
    return phpJsonTruthy(prefix) ? phpJsonString(prefix) + (number !== null ? ' ' + phpJsonString(number) : '')
        : number !== null ? number : '';
}

/** Existing scene room-key formatter, shared with display-only destination pickers. */
export function roomMapKeyLabel(prefix: string, key: string): string {
    const normalized = String(key ?? '').trim();
    return normalized ? `${prefix.trim()} ${normalized}`.trim() : '';
}
